module.exports = __webpack_public_path__ + "static/media/Outdoor_2.33688b0f.jpeg";